import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgVechten = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#85E3F9"
      d="m29.68 6.55-1.59 3.03 3.16 1.32-3.19 1.25 1.6 3.03-3.62-.91-1.61 3.36-1.86-3.21-3.59.94 1.74-3.26-2.65-2.59 3.67-.66.09-3.72 2.44 2.31 1.67-2.92.63 3.29z"
    />
    <path
      fill="#85E3F9"
      fillRule="evenodd"
      d="M12.67 19.78A5.33 5.33 0 0 1 18 25.11V34H7.33v-8.89a5.34 5.34 0 0 1 5.34-5.33"
      clipRule="evenodd"
    />
    <path
      fill="#85E3F9"
      d="M12.67 19.77a5.33 5.33 0 1 0 0-10.66 5.33 5.33 0 0 0 0 10.66"
    />
    <path
      fill="#00C5F2"
      d="M27.33 19.77a5.33 5.33 0 1 0 0-10.66 5.33 5.33 0 0 0 0 10.66"
    />
    <path
      fill="#00C5F2"
      fillRule="evenodd"
      d="M27.33 19.78A5.33 5.33 0 0 0 22 25.11V34h10.67v-8.89a5.34 5.34 0 0 0-5.34-5.33"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="m12.488 22.986.182-.466.182-.465h.002l.011.004.05.019q.071.025.21.069c.184.057.455.132.79.201a8.9 8.9 0 0 0 2.616.154c2.003-.192 4.402-1.201 5.954-4.6l.91.416c-1.718 3.761-4.454 4.957-6.768 5.18a9.9 9.9 0 0 1-4.112-.502l-.019-.007-.006-.002z"
      clipRule="evenodd"
    />
    <path
      fill="#85E3F9"
      d="M22.94 19.55a1.89 1.89 0 1 0 0-3.78 1.89 1.89 0 0 0 0 3.78"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M14.625 15.843a2.63 2.63 0 0 0-2.626 2.779l-.998.056a3.63 3.63 0 1 1 7.248 0l-.998-.056a2.63 2.63 0 0 0-2.626-2.779"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgVechten);

export default ForwardRef;
